import "./accreditation.css";
import cogniaImg from "./images/accreditation/cognia.webp";
import waBoardImg from "./images/accreditation/wa-board-of-education.webp";
import apSchoolImg from "./images/accreditation/ap-school.png";
import dhsImg from "./images/accreditation/dhs-sevp.webp";

const CREDENTIALS = [
  {
    eyebrow: "Accreditation",
    title: "Cognia Accredited",
    description:
      "U.S. accreditation, recognized globally — the same agency that accredits American public school districts.",
    image: cogniaImg,
    alt: "Cognia Accredited",
  },
  {
    eyebrow: "State Approval",
    title: "Washington State Board of Education",
    description:
      "Officially approved as a private school by Washington state, affirming that SVT meets all state requirements for educational excellence.",
    image: waBoardImg,
    alt: "Washington State Board of Education",
  },
  {
    eyebrow: "College Board",
    title: "Official AP School",
    description:
      "Authorized to provide Advanced Placement courses for our students and the wider community.",
    image: apSchoolImg,
    alt: "Official AP School",
  },
  {
    eyebrow: "Federal Authorization",
    title: "SEVP-Certified by DHS",
    description:
      "Authorized by the U.S. Department of Homeland Security to issue Form I-20, enabling international students to enroll on an F-1 visa.",
    image: dhsImg,
    alt: "U.S. Department of Homeland Security SEVP",
  },
];

const Accreditation = () => {
  return (
    <div className="accreditation-page">
      <div className="accreditation-container">
        <h1 className="accreditation-title">Accreditation</h1>

        {/* Intro hidden for now
        <p className="accreditation-intro">
          Seattle Voctech High School is <strong>fully accredited by Cognia</strong>{" "}
          — U.S. accreditation, recognized globally, the same agency that
          accredits American public school districts. Our accreditation includes
          the{" "}
          <strong>
            North Central Association Commission on Accreditation and School
            Improvement (NCA CASI)
          </strong>
          , the <strong>Northwest Accreditation Commission (NWAC)</strong>, and
          the{" "}
          <strong>
            Southern Association of Colleges and Schools Council on Accreditation
            and School Improvement (SACS CASI)
          </strong>{" "}
          — the regional accrediting agencies that span the Cognia global
          network.
        </p>
        */}

        <div className="accreditation-grid">
          {CREDENTIALS.map((item) => (
            <article key={item.title} className="accreditation-card">
              <div className="accreditation-card-image-wrap">
                <img src={item.image} alt={item.alt} />
              </div>
              <p className="accreditation-card-eyebrow">{item.eyebrow}</p>
              <h2 className="accreditation-card-title">{item.title}</h2>
              <p className="accreditation-card-description">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Accreditation;
